import React from 'react';

interface props {
  reportdata: {
    zipcode: string;
    city: string;
    products: Array<{
      name: string;
      weeks: Record<string, number>;
    }>;
  };
}

const AdminDeliveryReportTable: React.FC<props> = ({ reportdata }) => {
  if (!reportdata || !reportdata.products) {
    return <div>No report data available</div>;
  }

  const weeks = Object.keys(reportdata.products[0]?.weeks || {});
  const months = Array.from(new Set(weeks.map(w => w.split('-')[0])));

  return (
    <div style={{ overflowX: 'auto' }}>
      <table className="grid" style={{ minWidth: '100%' }}>
        <thead>
          <tr>
            <th style={{ minWidth: '150px' }}>Product</th>
            {months.map(month => (
              <th key={month} colSpan={4} style={{ textAlign: 'center' }}>
                {month}
              </th>
            ))}
          </tr>
          <tr>
            <th style={{ minWidth: '150px' }}></th>
            {weeks.map(week => (
              <th key={week} style={{ minWidth: '50px', textAlign: 'center' }}>
                {week.split('-')[1]}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {reportdata.products.map((product, idx) => (
            <tr key={idx}>
              <td style={{ fontWeight: 'bold', minWidth: '150px' }}>{product.name}</td>
              {weeks.map(week => (
                <td key={week} style={{ textAlign: 'center', padding: '0.75rem' }}>
                  {product.weeks[week] || '-'}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AdminDeliveryReportTable;
